/*
 * tq-catalog — client-side filtering / sorting over the store's green coffees.
 * Progressive enhancement on top of the server-rendered catalog emitted by
 * snippets/tq-catalog.liquid (homepage + collection pages). Product data is
 * rendered as JSON (script[data-tq-catalog]); UI strings come from
 * window.tqStrings; add-to-cart uses the real Shopify AJAX Cart API.
 */
(function () {
  const root = document.querySelector('.tq-catalog');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const _dollar_global = (s) => document.querySelector(s);   // elements outside .tq-catalog (e.g. #tq-cc in global header)

  const S = window.tqStrings || {};
  const SYM = S.moneySymbol || '$';

  // ---- product data -------------------------------------------------------
  let DATA = [];
  try {
    DATA = JSON.parse(document.querySelector('[data-tq-catalog]').textContent) || [];
  } catch (e) {
    DATA = [];
  }

  // Origin country: prefer the Shopify category metafield "Pays" (shopify.country),
  // emitted as `coTax` = [{label, taxonomy_reference}, …]. Its taxonomy-value label
  // ("Nicaragua", "Pérou", …) is clean and localized, so it maps to a flag reliably
  // where the legacy free-text `co` (origine) often didn't. Keep the taxonomy_reference
  // GID around (coTaxId) as a language-independent key for future use. Fall back to the
  // origine value already in `co` for products with no category country set.
  DATA.forEach((c) => {
    const t = Array.isArray(c.coTax) ? c.coTax[0] : null;
    if (t && t.label) c.co = t.label;
    if (t && t.taxonomy_reference) c.coTaxId = t.taxonomy_reference;
  });

  // Coffee-producing origins of the world ("the bean belt"), hardcoded.
  // Each entry: [continent, flag emoji, [name variants in EN / FR / ES]].
  // The `origine` metafield may be filled in any of the store's working
  // languages (and with or without accents), so every spelling we expect maps
  // to the same flag + continent grouping. Add new spellings to the same row.
  const ORIGINS = [
    // ---- Africa ----
    ['Africa', '🇪🇹', ['Ethiopia', 'Éthiopie', 'Ethiopie', 'Etiopía', 'Etiopia']],
    ['Africa', '🇰🇪', ['Kenya']],
    ['Africa', '🇷🇼', ['Rwanda']],
    ['Africa', '🇧🇮', ['Burundi']],
    ['Africa', '🇹🇿', ['Tanzania', 'Tanzanie', 'Tanzanía']],
    ['Africa', '🇺🇬', ['Uganda', 'Ouganda']],
    ['Africa', '🇨🇩', ['DR Congo', 'DRC', 'RDC', 'RD Congo', 'Congo', 'Democratic Republic of the Congo', 'République démocratique du Congo', 'Republique democratique du Congo', 'República Democrática del Congo']],
    ['Africa', '🇨🇬', ['Republic of the Congo', 'Congo-Brazzaville', 'République du Congo', 'República del Congo']],
    ['Africa', '🇨🇲', ['Cameroon', 'Cameroun', 'Camerún', 'Camerun']],
    ['Africa', '🇨🇮', ["Ivory Coast", "Côte d'Ivoire", "Cote d'Ivoire", 'Costa de Marfil']],
    ['Africa', '🇿🇲', ['Zambia', 'Zambie', 'Zambia']],
    ['Africa', '🇲🇼', ['Malawi', 'Malaui']],
    ['Africa', '🇿🇼', ['Zimbabwe', 'Zimbabue']],
    ['Africa', '🇲🇬', ['Madagascar']],
    ['Africa', '🇦🇴', ['Angola']],
    ['Africa', '🇹🇬', ['Togo']],
    ['Africa', '🇬🇳', ['Guinea', 'Guinée', 'Guinee']],
    ['Africa', '🇸🇱', ['Sierra Leone', 'Sierra Léone', 'Sierra Leona']],
    ['Africa', '🇳🇬', ['Nigeria', 'Nigéria']],
    ['Africa', '🇬🇭', ['Ghana']],
    ['Africa', '🇸🇸', ['South Sudan', 'Soudan du Sud', 'Sudán del Sur', 'Sudan del Sur']],
    ['Africa', '🇸🇭', ['Saint Helena', 'Sainte-Hélène', 'Sainte-Helene', 'Santa Elena']],
    // ---- South America ----
    ['South America', '🇨🇴', ['Colombia', 'Colombie']],
    ['South America', '🇧🇷', ['Brazil', 'Brésil', 'Bresil', 'Brasil']],
    ['South America', '🇵🇪', ['Peru', 'Pérou', 'Perou', 'Perú']],
    ['South America', '🇪🇨', ['Ecuador', 'Équateur', 'Equateur']],
    ['South America', '🇧🇴', ['Bolivia', 'Bolivie']],
    ['South America', '🇻🇪', ['Venezuela', 'Vénézuela', 'Venezuela']],
    ['South America', '🇬🇾', ['Guyana', 'Guyana']],
    // ---- Central America & Caribbean ----
    ['Central America', '🇭🇳', ['Honduras']],
    ['Central America', '🇬🇹', ['Guatemala']],
    ['Central America', '🇨🇷', ['Costa Rica']],
    ['Central America', '🇳🇮', ['Nicaragua']],
    ['Central America', '🇸🇻', ['El Salvador', 'Salvador']],
    ['Central America', '🇵🇦', ['Panama', 'Panamá']],
    ['Central America', '🇨🇺', ['Cuba']],
    ['Central America', '🇩🇴', ['Dominican Republic', 'République dominicaine', 'Republique dominicaine', 'República Dominicana', 'Republica Dominicana']],
    ['Central America', '🇭🇹', ['Haiti', 'Haïti', 'Haití']],
    ['Central America', '🇯🇲', ['Jamaica', 'Jamaïque', 'Jamaique', 'Jamaica']],
    ['Central America', '🇵🇷', ['Puerto Rico', 'Porto Rico']],
    // ---- North America ----
    ['North America', '🇲🇽', ['Mexico', 'Mexique', 'México', 'Méjico', 'Mejico']],
    // ---- Asia ----
    ['Asia', '🇮🇩', ['Indonesia', 'Indonésie', 'Indonesie']],
    ['Asia', '🇮🇳', ['India', 'Inde']],
    ['Asia', '🇻🇳', ['Vietnam', 'Viêt Nam', 'Viet Nam', 'Việt Nam']],
    ['Asia', '🇾🇪', ['Yemen', 'Yémen', 'Yemen']],
    ['Asia', '🇨🇳', ['China', 'Chine']],
    ['Asia', '🇱🇦', ['Laos']],
    ['Asia', '🇹🇭', ['Thailand', 'Thaïlande', 'Thailande', 'Tailandia']],
    ['Asia', '🇵🇭', ['Philippines', 'Filipinas']],
    ['Asia', '🇲🇲', ['Myanmar', 'Burma', 'Birmanie', 'Birmania']],
    ['Asia', '🇹🇱', ['Timor-Leste', 'East Timor', 'Timor oriental', 'Timor Oriental']],
    ['Asia', '🇳🇵', ['Nepal', 'Népal']],
    ['Asia', '🇱🇰', ['Sri Lanka']],
    ['Asia', '🇲🇾', ['Malaysia', 'Malaisie', 'Malasia']],
    // ---- Oceania / Pacific ----
    ['Oceania', '🇵🇬', ['Papua New Guinea', 'PNG', 'Papouasie-Nouvelle-Guinée', 'Papouasie-Nouvelle-Guinee', 'Papúa Nueva Guinea', 'Papua Nueva Guinea']],
    ['Oceania', '🇺🇸', ['Hawaii', 'Hawaï', 'Hawai', 'Hawái']],
    ['Oceania', '🇦🇺', ['Australia', 'Australie']],
    ['Oceania', '🇳🇨', ['New Caledonia', 'Nouvelle-Calédonie', 'Nouvelle-Caledonie', 'Nueva Caledonia']],
    ['Oceania', '🇻🇺', ['Vanuatu']],
    ['Oceania', '🇫🇯', ['Fiji', 'Fidji', 'Fiyi']],
    ['Oceania', '🇼🇸', ['Samoa']],
  ];
  const CONT = ['South America', 'Africa', 'Central America', 'North America', 'Oceania', 'Asia'];
  const CONT_LABEL = S.continents || {};
  const COUNTRY_TO_CONTINENT = {};
  const COUNTRY_TO_FLAG = {};
  ORIGINS.forEach(([cont, flag, names]) => names.forEach((n) => {
    COUNTRY_TO_CONTINENT[n] = cont;
    COUNTRY_TO_FLAG[n] = flag;
  }));
  const OTHER = S.other || 'Other';
  const norm = (s) => String(s == null ? '' : s).trim();
  const continentOf = (co) => COUNTRY_TO_CONTINENT[norm(co)] || OTHER;
  const contLabel = (k) => CONT_LABEL[k] || k;
  const flagOf = (co) => COUNTRY_TO_FLAG[norm(co)] || '';

  // ---- state --------------------------------------------------------------
  const f = { countries: [], procs: [], pMin: null, pMax: null, sale: false, stock: false };
  let sort = 'latest';

  const perLbOf = (s) => (s.w > 0 ? s.p / s.w : s.p);
  const minP = (c) => Math.min.apply(null, c.sizes.map((s) => s.p));
  const perLbRange = (c) => {
    const v = c.sizes.map(perLbOf);
    return [Math.min.apply(null, v), Math.max.apply(null, v)];
  };
  const inStock = (c) => c.sizes.some((s) => s.a !== 'out');
  const fmt = (str, vars) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));

  function sorted() {
    let a = DATA.filter((c) => {
      if (f.countries.length && !f.countries.includes(c.co)) return false;
      if (f.procs.length && !f.procs.includes(c.proc)) return false;
      if (f.sale && !c.sale) return false;
      if (f.stock && !inStock(c)) return false;
      const [lo, hi] = perLbRange(c);
      if (f.pMin != null && hi < f.pMin) return false;
      if (f.pMax != null && lo > f.pMax) return false;
      return true;
    });
    const cmp = {
      latest: (x, y) => String(y.date).localeCompare(String(x.date)),
      'price-asc': (x, y) => minP(x) - minP(y),
      'price-desc': (x, y) => minP(y) - minP(x),
      alpha: (x, y) => (x.co + x.nm).localeCompare(y.co + y.nm),
      origin: (x, y) => CONT.indexOf(continentOf(x.co)) - CONT.indexOf(continentOf(y.co)) || String(x.co).localeCompare(y.co),
    }[sort];
    a.sort(cmp);
    a.sort((x, y) => (y.sale ? 1 : 0) - (x.sale ? 1 : 0)); // sale first
    // Fully out-of-stock products always sink to the bottom (most dominant,
    // applied last) — except under alphabetical sort, which stays a pure A→Z list.
    if (sort !== 'alpha') {
      a.sort((x, y) => (inStock(x) ? 0 : 1) - (inStock(y) ? 0 : 1));
    }
    return a;
  }

  function render() {
    const a = sorted();
    $('#tq-n').textContent = a.length;
    const list = $('#tq-list');
    const cards = list.querySelectorAll('.row');
    const cardById = {};
    cards.forEach(function (c) { cardById[c.dataset.id] = c; });
    const visible = new Set(a.map(function (x) { return String(x.id); }));

    // Show/hide
    cards.forEach(function (c) {
      c.style.display = visible.has(c.dataset.id) ? '' : 'none';
    });

    // Zero state: active filters match no coffee
    const noMatch = $('#tq-noMatch');
    if (noMatch) noMatch.hidden = a.length > 0 || !cards.length;

    // Reorder: appendChild moves the node to the end, so iterating in
    // sorted order produces the correct final order.
    a.forEach(function (item) {
      var card = cardById[String(item.id)];
      if (card) list.appendChild(card);
    });

    // Add flag emoji to org spans that don't have one yet (injected once).
    list.querySelectorAll('.org').forEach(function (el) {
      if (el.querySelector('.flag')) return;           // already done
      var co = el.textContent.trim();
      var f = flagOf(co);
      if (f) el.insertAdjacentHTML('afterbegin', '<span class="flag">' + f + '</span> ');
    });
  }

  function toast(m, ms) {
    const t = $('#tq-toast');
    t.textContent = m;
    t.classList.add('show');
    clearTimeout(toast._);
    toast._ = setTimeout(() => t.classList.remove('show'), ms || 1700);
  }

  // ---- build Origin + Process menus from the data -------------------------
  const byCont = {};
  DATA.forEach((c) => {
    if (!c.co) return;
    const k = continentOf(c.co);
    (byCont[k] = byCont[k] || new Set()).add(c.co);
  });
  const contOrder = CONT.filter((k) => byCont[k]).concat(byCont[OTHER] ? [OTHER] : []);
  const RESET_BTN = `<button class="mreset" type="button">${S.reset || 'Reset'}</button>`;
  $('#tq-mOrigin').innerHTML = contOrder.map((k) => {
    const cos = [...byCont[k]].sort();
    return `<div><button class="ocont" data-cont="${k}"><span class="cbx"></span>${contLabel(k)}</button>
      <div class="ocountries">${cos.map((co) => `<label class="opt"><input type="checkbox" class="cbx-input" data-co="${co}"><span class="cbx"></span>${flagOf(co) ? `<span class="flag">${flagOf(co)}</span> ` : ''}${co}</label>`).join('')}</div></div>`;
  }).join('') + RESET_BTN;
  const PROCS = [...new Set(DATA.map((c) => c.proc).filter(Boolean))];
  $('#tq-mProc').innerHTML = PROCS.map((p) => `<label class="opt"><input type="checkbox" class="cbx-input" data-proc="${p}"><span class="cbx"></span>${p}</label>`).join('') + RESET_BTN;

  // ---- build mobile combined menu (same data, separate DOM) ---------------
  $('#tq-mobOrigins').innerHTML = contOrder.map((k) => {
    const cos = [...byCont[k]].sort();
    return `<div><button class="ocont" data-cont="${k}"><span class="cbx"></span>${contLabel(k)}</button>
      <div class="ocountries">${cos.map((co) => `<label class="opt"><input type="checkbox" class="cbx-input" data-co="${co}"><span class="cbx"></span>${flagOf(co) ? `<span class="flag">${flagOf(co)}</span> ` : ''}${co}</label>`).join('')}</div></div>`;
  }).join('');
  $('#tq-mobProcs').innerHTML = PROCS.map((p) => `<label class="opt"><input type="checkbox" class="cbx-input" data-proc="${p}"><span class="cbx"></span>${p}</label>`).join('');

  // hide empty sections in the mobile menu
  if (!contOrder.length) $('#tq-mobOriginsSec').hidden = true;
  if (!PROCS.length) $('#tq-mobProcsSec').hidden = true;

  function syncMenus() {
    $('#tq-mOrigin').querySelectorAll('.cbx-input[data-co]').forEach((b) => { b.checked = f.countries.includes(b.dataset.co); });
    $('#tq-mOrigin').querySelectorAll('.ocont').forEach((b) => {
      const cos = [...byCont[b.dataset.cont]];
      b.querySelector('.cbx').classList.toggle('on', cos.every((co) => f.countries.includes(co)));
    });
    $('#tq-mProc').querySelectorAll('.cbx-input[data-proc]').forEach((b) => { b.checked = f.procs.includes(b.dataset.proc); });

    // mobile combined menu mirrors
    $('#tq-mobOrigins').querySelectorAll('.cbx-input[data-co]').forEach((b) => { b.checked = f.countries.includes(b.dataset.co); });
    $('#tq-mobOrigins').querySelectorAll('.ocont').forEach((b) => {
      const cos = [...byCont[b.dataset.cont]];
      b.querySelector('.cbx').classList.toggle('on', cos.every((co) => f.countries.includes(co)));
    });
    $('#tq-mobProcs').querySelectorAll('.cbx-input[data-proc]').forEach((b) => { b.checked = f.procs.includes(b.dataset.proc); });
    $('#tq-mobSale').checked = f.sale;
    $('#tq-mobStock').checked = f.stock;

    // sync price inputs both ways
    if (document.activeElement !== $('#tq-pMinMob')) $('#tq-pMinMob').value = f.pMin == null ? '' : f.pMin;
    if (document.activeElement !== $('#tq-pMaxMob')) $('#tq-pMaxMob').value = f.pMax == null ? '' : f.pMax;
    if (document.activeElement !== $('#tq-pMin')) $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    if (document.activeElement !== $('#tq-pMax')) $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
  }

  let ACTS = [];
  function chip(label, fn) {
    const i = ACTS.push(fn) - 1;
    return `<button class="ac" data-i="${i}">${label}<span class="x">×</span></button>`;
  }
  function renderChips() {
    ACTS = [];
    const out = [];
    f.countries.forEach((co) => out.push(chip(co, () => { f.countries = f.countries.filter((x) => x !== co); })));
    f.procs.forEach((p) => out.push(chip(p, () => { f.procs = f.procs.filter((x) => x !== p); })));
    if (f.sale) out.push(chip(S.sale || 'On sale', () => { f.sale = false; }));
    if (f.stock) out.push(chip(S.stockFilter || (S.stock && S.stock.in) || 'In stock', () => { f.stock = false; }));
    if (f.pMin != null || f.pMax != null) {
      out.push(chip(`${f.pMin != null ? SYM + f.pMin : SYM + '0'}–${f.pMax != null ? SYM + f.pMax : '∞'}${S.perLb || '/lb'}`, () => { f.pMin = f.pMax = null; }));
    }
    $('#tq-chips').innerHTML = out.length ? out.join('') + `<button class="clr" id="tq-clrAll">${S.clearAll || 'Clear all'}</button>` : '';
  }

  // ---- URL hash state -------------------------------------------------------
  // Filter + sort state lives in the URL hash (#co=…&proc=…&pmin=…&pmax=…&
  // sale=1&stock=1&sort=…) so a filtered view survives reloads and can be
  // shared. The collection section also maps legacy ?filter.v.availability=1
  // URLs onto #stock=1, so old in-stock-only links land on the same filter.
  function readHash() {
    const h = location.hash.replace(/^#/, '');
    if (!h) return;
    const p = new URLSearchParams(h);
    if (p.get('co')) f.countries = p.get('co').split('~').filter(Boolean);
    if (p.get('proc')) f.procs = p.get('proc').split('~').filter(Boolean);
    if (p.get('pmin')) f.pMin = +p.get('pmin');
    if (p.get('pmax')) f.pMax = +p.get('pmax');
    if (p.has('sale')) f.sale = true;
    if (p.has('stock')) f.stock = true;
    const s = p.get('sort');
    if (s && $('#tq-sort').querySelector('option[value="' + s + '"]')) {
      sort = s;
      $('#tq-sort').value = s;
    }
  }
  function writeHash() {
    const p = new URLSearchParams();
    if (f.countries.length) p.set('co', f.countries.join('~'));
    if (f.procs.length) p.set('proc', f.procs.join('~'));
    if (f.pMin != null) p.set('pmin', f.pMin);
    if (f.pMax != null) p.set('pmax', f.pMax);
    if (f.sale) p.set('sale', '1');
    if (f.stock) p.set('stock', '1');
    if (sort !== 'latest') p.set('sort', sort);
    const q = p.toString();
    history.replaceState(null, '', q ? '#' + q : location.pathname + location.search);
  }

  function badge(el, n) { el.textContent = n; el.hidden = !n; }
  function update() {
    writeHash();
    render();
    renderChips();
    syncMenus();
    badge($('#tq-ctOrigin'), f.countries.length);
    badge($('#tq-ctProc'), f.procs.length);
    badge($('#tq-ctPrice'), (f.pMin != null || f.pMax != null) ? 1 : '');
    $('#tq-fSale').classList.toggle('on', f.sale);
    $('#tq-fStock').classList.toggle('on', f.stock);
    // combined mobile badge: total active filters
    const total = f.countries.length + f.procs.length + (f.pMin != null || f.pMax != null ? 1 : 0) + (f.sale ? 1 : 0) + (f.stock ? 1 : 0);
    badge($('#tq-ctAll'), total);
    // highlight mobile filter button when any filter is active
    $('#tq-bAll').classList.toggle('on', total > 0);
  }

  // ---- cart ---------------------------------------------------------------
  const cartCountEl = _dollar_global('#tq-cc');
  const cartLinkEl = _dollar_global('#tq-cart');
  function setCount(n) {
    cartCountEl.textContent = n;
    cartCountEl.hidden = !n;
    if (cartLinkEl) {
      const tpl = cartLinkEl.getAttribute('data-cart-label-template');
      if (tpl) cartLinkEl.setAttribute('aria-label', tpl.replace('%n', n));
    }
  }
  async function refreshCount() {
    try {
      const r = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      setCount(cart.item_count);
    } catch (e) { /* leave count as-is */ }
  }
  // Pull a readable message out of a failed cart/add response, across the
  // different shapes Shopify uses (errors string, errors object, description).
  function cartErrorMessage(data) {
    if (!data) return '';
    const e = data.errors;
    if (typeof e === 'string') return e;
    if (e && typeof e === 'object') {
      return Object.keys(e).map((k) => [].concat(e[k]).join(' ')).join(' ').trim();
    }
    return data.description || data.message || '';
  }
  async function addToCart(variantId, label, btn) {
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        // Surface Shopify's human-readable reason (e.g. stock too low) instead
        // of a generic error. The shape varies: stock/quantity errors come back
        // as `errors` (a string, or an object of field -> [messages]); other
        // cart errors use `description`/`message`. Keep the generic message as a
        // prefix so the customer still gets context, e.g. "Something went wrong: …".
        const generic = S.cartError || 'Something went wrong';
        const reason = cartErrorMessage(data);
        toast(reason ? `${generic}: ${reason}` : generic, 4000);
        return;
      }
      await refreshCount();
      toast(fmt(S.added || 'Added {name}', { name: label }));
      // Let the theme's cart drawer/bubble refresh if it is listening.
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'home-catalog' });
      }
    } catch (e) {
      toast(S.cartError || 'Something went wrong');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  // ---- events -------------------------------------------------------------
  $('#tq-list').addEventListener('click', (e) => {
    // More-info toggle
    const more = e.target.closest('.more-btn');
    if (more) {
      const expanded = more.getAttribute('aria-expanded') === 'true';
      more.setAttribute('aria-expanded', !expanded);
      const panel = document.getElementById(more.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded; // inverted: if was open, close
    }
  });

  // Add to cart — each .sb is a real <form action="/cart/add">, so the button
  // works natively before this script loads (or with JS off). Once we're here,
  // intercept the submit (covers mouse + keyboard) and do the AJAX add instead.
  $('#tq-list').addEventListener('submit', (e) => {
    const form = e.target.closest('form.sb');
    if (!form) return;
    e.preventDefault();
    const b = form.querySelector('.add[data-variant]');
    if (!b || b.disabled) return;
    addToCart(b.dataset.variant, b.dataset.label, b);
  });

  $('#tq-mOrigin').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.countries = [];
      update();
      return;
    }
    const cont = e.target.closest('.ocont');
    if (cont) {
      const cos = [...byCont[cont.dataset.cont]];
      const all = cos.every((c) => f.countries.includes(c));
      f.countries = all ? f.countries.filter((c) => !cos.includes(c)) : [...new Set([...f.countries, ...cos])];
      update();
    }
  });
  $('#tq-mOrigin').addEventListener('change', (e) => {
    const co = e.target.closest('.cbx-input[data-co]');
    if (!co) return;
    const v = co.dataset.co;
    f.countries = f.countries.includes(v) ? f.countries.filter((x) => x !== v) : [...f.countries, v];
    update();
  });
  $('#tq-mProc').addEventListener('click', (e) => {
    if (e.target.closest('.mreset')) {
      f.procs = [];
      update();
    }
  });
  $('#tq-mProc').addEventListener('change', (e) => {
    const p = e.target.closest('.cbx-input[data-proc]');
    if (!p) return;
    const v = p.dataset.proc;
    f.procs = f.procs.includes(v) ? f.procs.filter((x) => x !== v) : [...f.procs, v];
    update();
  });

  function priceFromInputs() {
    const a = $('#tq-pMin').value;
    const b = $('#tq-pMax').value;
    f.pMin = a === '' ? null : +a;
    f.pMax = b === '' ? null : +b;
    update();
  }
  $('#tq-pMin').addEventListener('input', priceFromInputs);
  $('#tq-pMax').addEventListener('input', priceFromInputs);
  $('#tq-mPrice').querySelectorAll('.ppre button').forEach((b) => b.addEventListener('click', () => {
    f.pMin = b.dataset.min === '' ? null : +b.dataset.min;
    f.pMax = b.dataset.max === '' ? null : +b.dataset.max;
    $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
    update();
  }));
  $('#tq-pReset').addEventListener('click', () => {
    f.pMin = f.pMax = null;
    $('#tq-pMin').value = '';
    $('#tq-pMax').value = '';
    update();
  });

  function clearAllFilters() {
    f.countries = []; f.procs = []; f.pMin = f.pMax = null; f.sale = f.stock = false;
    $('#tq-pMin').value = ''; $('#tq-pMax').value = '';
    $('#tq-pMinMob').value = ''; $('#tq-pMaxMob').value = '';
    update();
  }
  const noMatchClr = $('#tq-noMatchClr');
  if (noMatchClr) noMatchClr.addEventListener('click', clearAllFilters);

  $('#tq-chips').addEventListener('click', (e) => {
    if (e.target.id === 'tq-clrAll') {
      clearAllFilters();
      return;
    }
    const b = e.target.closest('[data-i]');
    if (!b) return;
    ACTS[+b.dataset.i]();
    $('#tq-pMin').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMax').value = f.pMax == null ? '' : f.pMax;
    update();
  });

  $('#tq-fSale').addEventListener('click', () => { f.sale = !f.sale; update(); });
  $('#tq-fStock').addEventListener('click', () => { f.stock = !f.stock; update(); });
  $('#tq-sort').addEventListener('change', (e) => { sort = e.target.value; update(); });

  // ---- mobile combined menu events ----------------------------------------
  // Origin clicks — same logic as desktop
  $('#tq-mobOrigins').addEventListener('click', (e) => {
    const cont = e.target.closest('.ocont');
    if (!cont) return;
    const cos = [...byCont[cont.dataset.cont]];
    const all = cos.every((c) => f.countries.includes(c));
    f.countries = all ? f.countries.filter((c) => !cos.includes(c)) : [...new Set([...f.countries, ...cos])];
    update();
  });
  $('#tq-mobOrigins').addEventListener('change', (e) => {
    const co = e.target.closest('.cbx-input[data-co]');
    if (!co) return;
    const v = co.dataset.co;
    f.countries = f.countries.includes(v) ? f.countries.filter((x) => x !== v) : [...f.countries, v];
    update();
  });
  // Process clicks
  $('#tq-mobProcs').addEventListener('change', (e) => {
    const p = e.target.closest('.cbx-input[data-proc]');
    if (!p) return;
    const v = p.dataset.proc;
    f.procs = f.procs.includes(v) ? f.procs.filter((x) => x !== v) : [...f.procs, v];
    update();
  });
  // Mobile price inputs — sync to state
  function priceFromMobInputs() {
    const a = $('#tq-pMinMob').value;
    const b = $('#tq-pMaxMob').value;
    f.pMin = a === '' ? null : +a;
    f.pMax = b === '' ? null : +b;
    update();
  }
  $('#tq-pMinMob').addEventListener('input', priceFromMobInputs);
  $('#tq-pMaxMob').addEventListener('input', priceFromMobInputs);
  // Mobile price presets
  $('#tq-mobPriceSec').querySelectorAll('.ppre button').forEach((b) => b.addEventListener('click', () => {
    f.pMin = b.dataset.min === '' ? null : +b.dataset.min;
    f.pMax = b.dataset.max === '' ? null : +b.dataset.max;
    $('#tq-pMinMob').value = f.pMin == null ? '' : f.pMin;
    $('#tq-pMaxMob').value = f.pMax == null ? '' : f.pMax;
    update();
  }));
  // Mobile sale / stock toggles
  $('#tq-mobSale').addEventListener('change', (e) => { f.sale = e.target.checked; update(); });
  $('#tq-mobStock').addEventListener('change', (e) => { f.stock = e.target.checked; update(); });
  // Mobile clear all
  $('#tq-mobClrAll').addEventListener('click', clearAllFilters);

  // ---- popover open/close (desktop) ---------------------------------------
  [['tq-bOrigin', 'tq-mOrigin'], ['tq-bProc', 'tq-mProc'], ['tq-bPrice', 'tq-mPrice']].forEach(([b, m]) => {
    $('#' + b).addEventListener('click', (e) => {
      e.stopPropagation();
      const menu = $('#' + m);
      const open = !menu.hidden;
      root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
      menu.hidden = open;
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.pop')) root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
  });

  // ---- mobile filter panel open/close ------------------------------------
  const mobOverlay = $('#tq-mobOverlay');
  function openMob() {
    mobOverlay.classList.add('mob-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    mobOverlay.classList.remove('mob-open');
    document.body.style.overflow = '';
  }
  $('#tq-bAll').addEventListener('click', (e) => {
    e.stopPropagation();
    if (mobOverlay.classList.contains('mob-open')) {
      closeMob();
    } else {
      // close any open desktop menus first
      root.querySelectorAll('.menu').forEach((x) => { x.hidden = true; });
      openMob();
    }
  });
  // backdrop click → close
  mobOverlay.querySelector('.tq-mob-backdrop').addEventListener('click', closeMob);
  // close button → close
  $('#tq-mobClose').addEventListener('click', closeMob);
  // close mobile panel if user resizes past the mobile breakpoint
  window.addEventListener('resize', () => {
    if (window.innerWidth > 820 && mobOverlay.classList.contains('mob-open')) closeMob();
  });

  // sticky bar shadow
  const sent = document.createElement('div');
  sent.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
  root.prepend(sent);
  new IntersectionObserver(([x]) => $('#tq-bar').classList.toggle('stuck', !x.isIntersecting), { threshold: 1 }).observe(sent);

  // seed cart count rendered by Liquid, then apply hash state and render
  const seeded = parseInt(cartCountEl && cartCountEl.dataset.count, 10);
  if (!isNaN(seeded)) setCount(seeded);

  readHash();
  update();

  window.addEventListener('hashchange', () => {
    f.countries = []; f.procs = []; f.pMin = f.pMax = null; f.sale = f.stock = false;
    sort = 'latest';
    $('#tq-sort').value = sort;
    readHash();
    update();
  });
})();
